import { useEffect, useState } from 'react'

import { api } from '../core/trpc'

export const useFileImage = (fileId: string | undefined) => {
    const [imageUrl, setImageUrl] = useState<string>()
    const [isLoading, setIsLoading] = useState(!!fileId)
    const { mutateAsync: downloadFile } = api.file.download.useMutation()

    useEffect(() => {
        setImageUrl(undefined)
        if (!fileId) {
            setIsLoading(false)
            return
        }

        let active = true
        setIsLoading(true)
        downloadFile({ id: fileId })
            .then((data) => active && setImageUrl(`data:${data.mimeType};base64,${data.data}`))
            .catch(() => undefined)
            .finally(() => active && setIsLoading(false))

        return () => {
            active = false
        }
    }, [fileId, downloadFile])

    return { imageUrl, isLoading }
}
